<template>
  <v-container fluid class="px-0">
    <v-row align="baseline" class="mb-3">
      <v-col cols="12" md="12">
        <el-button
          primary
          small
          :disabled="disabledIkeltiVisus"
          @click.native="ikeltiVisus()"
          >Įkelti visus</el-button
        >
        <el-button
          primary
          small
          :disabled="disabledIkeltiKriterijai"
          @click.native="ikeltiKriterijai()"
          >Įkelti pagal kriterijus</el-button
        >
      </v-col>
    </v-row>
    <template v-if="showForm">
      <div @keydown.enter.prevent="searchData()">
        <v-row>
          <v-col cols="12" md="4">
            <el-date-picker
              label="Objekto išregistravimo data nuo"
              tooltip="Archyvo naikinimas. Akto formavimas. Objekto išregistravimo data nuo"
              :readonly="isSearching"
              required
              v-model="formData.isregistravimo_data_nuo"
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-date-picker
              label="Objekto išregistravimo data iki"
              tooltip="Archyvo naikinimas. Akto formavimas. Objekto išregistravimo data iki"
              :readonly="isSearching"
              required
              v-model="formData.isregistravimo_data_iki"
            />
          </v-col>
          <v-col cols="12" md="8">
            <el-autocomplete
              :items="filteredObjektai"
              itemvalue="value"
              itemtext="text"
              multiple
              label="Objektas"
              tooltip="Archyvo naikinimas. Akto formavimas. Objektas"
              :readonly="visiObjektai || isSearching"
              :required="!visiObjektai"
              v-model="formData.objektai"
            />
          </v-col>
          <v-col cols="12" md="2" class="mt-2">
            <el-checkbox
              label="Visi objektai"
              :readonly="isSearching"
              v-model="visiObjektai"
            />
          </v-col>

          <v-col cols="12">
            <el-button
              primary
              :loading="loading"
              @click.native.stop="searchData()"
            >
              Ieškoti
            </el-button>
            <el-button :loading="loading" @click.native="clearData()">
              Išvalyti
            </el-button>
          </v-col>
        </v-row>
      </div>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NaikinimasFormavimasSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    loadDefault: null,
    visiObjektai: false,
    objektai: {},
    tempObjektai: [],
    formData: {},
    showSearch: false,
    isSearching: false,
    disabledIkeltiVisus: false,
    disabledIkeltiKriterijai: false,
  }),
  computed: {
    ...mapGetters(['searchParams']),
    filteredObjektai() {
      return Object.entries(this.objektai).map(([key, item]) => {
        return { value: key, text: item }
      })
    },
    showForm() {
      return this.showSearch && !this.disabledIkeltiKriterijai
    },
  },
  inject: {
    $validator: '$validator',
  },
  watch: {
    visiObjektai(val) {
      this.formData.visi_objektai = val
      if (val) {
        this.tempObjektai = this.formData.objektai
        this.formData.objektai = []
        return
      }
      this.formData.objektai = this.tempObjektai
    },
  },
  created() {
    this.getKlasif()
    // this.getData()
  },
  methods: {
    ikeltiVisus() {
      if (this.showSearch) {
        return
      }
      this.showSearch = true
      this.disabledIkeltiVisus = false
      this.disabledIkeltiKriterijai = true
      this.searchData()
    },
    ikeltiKriterijai() {
      if (this.showSearch) {
        return
      }
      this.$validator.reset()
      this.showSearch = true
      this.disabledIkeltiVisus = true
      this.disabledIkeltiKriterijai = false
    },
    getKlasif() {
      const data = {
        klasifikatoriai: ['admin_aktas_objektai'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.objektai = res.data.list.admin_aktas_objektai
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {})
    },
    searchData() {
      if (this.isSearching) {
        return
      }
      this.$validator.validateAll().then(res => {
        if (!res) {
          window._VMA.$emit('FORMAT_ERROR')
          return
        }
        this.isSearching = true
        this.$emit('search', this.formData)
      })
    },
    clearData() {
      this.isSearching = false
      this.$validator.reset()
      this.formData = {}
      this.visiObjektai = false
      this.showSearch = false
      this.disabledIkeltiVisus = false
      this.disabledIkeltiKriterijai = false
      this.$emit('cancel')
    },
  },
}
</script>
